import React, { useCallback, useEffect, useRef, useState } from 'react';
import InputTitleView from './InputTitleView';
import icDelete from 'Assets/img/recruitment/ic_delete.png';
import icDelete2 from 'Assets/img/recruitment/ic_delete@2x.png';
import icDelete3 from 'Assets/img/recruitment/ic_delete@3x.png';
import { getImageSet, onKeyPressSubmit } from 'Util/DataUtils';

const deleteButtons = getImageSet([icDelete, icDelete2, icDelete3]);
const MultiTextInputView = ({ title = '', required = false, subTitle = '', placeholder, name, value, onChange }) => {
  const inputRef = useRef();
  const [text, setText] = useState('');
  const onClickAdd = () => {
    if (text === '') return;
    onChange({ name, value: [...value, text] });
    setText('');
  };

  const handleFocusout = useCallback(() => {
    if (text === '') return;
    onChange({ name, value: [...value, text] });
    setText('');
  }, [text, value]);

  useEffect(() => {
    const ref = inputRef.current;
    ref.addEventListener('focusout', handleFocusout);
    return () => {
      ref.removeEventListener('focusout', handleFocusout);
    };
  }, [handleFocusout]);

  return (
    <div className="recruitment-multi-text-input-view">
      <InputTitleView title={title} required={required} subTitle={subTitle} />
      <div className="recruitment-multi-text-input-view-input-wrapper">
        <div
          className="item-wrapper"
          onClick={() => {
            inputRef.current.focus();
          }}
        >
          {value.length > 0 &&
            value.map((x, i) => (
              <div key={`${name}_${i}`} className="item">
                <div className="item-text">{x}</div>
                <img
                  {...deleteButtons}
                  alt="delete"
                  onClick={e => {
                    e.preventDefault();
                    onChange({ name, value: value.filter(v => v !== x) });
                  }}
                />
              </div>
            ))}
          <input placeholder={placeholder} ref={inputRef} value={text} onChange={e => setText(e.target.value)} onKeyPress={e => onKeyPressSubmit(e, onClickAdd)} />
        </div>
      </div>
    </div>
  );
};

export default MultiTextInputView;
